/* @type {string} */
const VALID_DIGIT_SEPARATOR = '.';

/**
 * @param thousandSeparator {string}
 * @param digitSeparator {string}
 *
 * @returns {function}
 */
export default function getNumberSortFunction(thousandSeparator, digitSeparator) {
    return function(a, b) {
        const aValue = normalizeValue(a, thousandSeparator, digitSeparator);
        const bValue = normalizeValue(b, thousandSeparator, digitSeparator);

        if (aValue === bValue) {
            return 0;
        }

        return aValue < bValue ? -1 : 1;
    };
}

/**
 * @param stringValue {string|number}
 * @param thousandSeparator {string}
 * @param digitSeparator {string}
 *
 * @returns {number}
 */
function normalizeValue(stringValue, thousandSeparator, digitSeparator) {
    if (typeof stringValue === 'number') {
        return stringValue;
    }
    let normalizedString = removeSpanFromString(stringValue);
    normalizedString = removeThousandSeparator(normalizedString, thousandSeparator);
    normalizedString = replaceDigitSeparator(normalizedString, digitSeparator);

    return parseFloat(normalizedString);
}

/**
 * @param stringValue {string}
 * @param thousandSeparator {string}
 *
 * @returns {*}
 */
function removeThousandSeparator(stringValue, thousandSeparator) {
    const replace = new RegExp(`\\${ thousandSeparator }`, 'g');

    return stringValue.replace(replace, '');
}

/**
 * @param stringValue {string}
 * @param digitSeparator {string}
 *
 * @returns {*}
 */
function replaceDigitSeparator(stringValue, digitSeparator) {
    if (VALID_DIGIT_SEPARATOR === digitSeparator) {
        return stringValue;
    }

    return stringValue.replace(digitSeparator, VALID_DIGIT_SEPARATOR);
}

/**
 * @param stringValue {string}
 *
 * @returns {string}
 */
function removeSpanFromString(stringValue) {
    const spanTagIndex = stringValue.indexOf('<span>');

    if (spanTagIndex === -1) {
        return stringValue;
    }

    return stringValue.substring(0, spanTagIndex);
}
